import type {
  BillingActiveEntityViewModel,
  BillingEntityActionIntent,
  BillingEntityActionViewModel,
} from "../types";

export const entityActionFor = (
  entity: BillingActiveEntityViewModel,
  type: BillingEntityActionIntent["type"]
): BillingEntityActionViewModel | undefined =>
  entity.actions.find(({ intent }) => intent.type === type);
